module.exports = __webpack_public_path__ + "static/media/Inveskal_image.80a21548.png";